// extracted by mini-css-extract-plugin
export default {"text":"EmptyModal_text__Zq-zW","offset":"EmptyModal_offset__JBFx1","modalContainer":"EmptyModal_modalContainer__C5AM5","modalHeader":"EmptyModal_modalHeader__2XIfq"};